import {
    Container,
    Title,
    SubTitle,
    TitlesContainer,
    InnerContainer,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/MainScreen.styled";
import InviteSection from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/InviteSection";
import RewardsSection from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/RewardsSection";
import ProgressBarSection from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/ProgressBarSection/ProgressBarSection";
import HowItWorksSection from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/HowItWorksSection/HowItWorksSection";
import { SWReactIcons } from "@similarweb/icons";
import type { IInvitation, IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";

const TOTAL_USERS = 127;

interface IMainScreenProps {
    onOpenStatusScreen: VoidFunction;
    invitationsList: IInvitation[];
    setInvitationsList: (invitations: IInvitation[]) => void;
    invitationCount: number;
    packages: IPackage[];
}

const MainScreen = ({
    onOpenStatusScreen,
    invitationsList,
    setInvitationsList,
    invitationCount,
    packages,
}: IMainScreenProps) => {
    const i18n = i18nFilter();

    return (
        <Container data-automation="main-screen">
            <TitlesContainer>
                <Title data-automation="main-title">{i18n("rewards_modal.main_screen.title")}</Title>
                <SubTitle data-automation="subtitle">
                    <SWReactIcons
                        iconName="users"
                        size="sm"
                    />
                    {i18n("rewards_modal.main_screen.subtitle", { number: TOTAL_USERS })}
                </SubTitle>
            </TitlesContainer>
            <InnerContainer>
                <InviteSection
                    onOpenStatusScreen={onOpenStatusScreen}
                    invitationsList={invitationsList}
                    setInvitationsList={setInvitationsList}
                />
                <RewardsSection
                    packages={packages}
                    invitationCount={invitationCount}
                />
                <ProgressBarSection
                    packages={packages}
                    invitationCount={invitationCount}
                />
                <HowItWorksSection />
            </InnerContainer>
        </Container>
    );
};

export default MainScreen;
